import { render } from "./PayrollPopup.vue?vue&type=template&id=1ce965b0&scoped=true"
import script from "./PayrollPopup.vue?vue&type=script&lang=js"
export * from "./PayrollPopup.vue?vue&type=script&lang=js"

import "./PayrollPopup.vue?vue&type=style&index=0&id=1ce965b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce965b0"]])

export default __exports__